import { render, staticRenderFns } from "./YellowCardTemplate.vue?vue&type=template&id=7a3d7eb6"
import script from "./YellowCardTemplate.vue?vue&type=script&lang=js"
export * from "./YellowCardTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports